export function formatQuantity(value: number, scale = 100): string {
  const amount = value / scale;
  if (amount >= 100) return Math.floor(amount).toLocaleString("en-GB");
  if (amount >= 10) return amount.toFixed(1).replace(/\.0$/, "");
  return amount.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
}

export function formatDuration(totalSeconds: number | null | undefined): string {
  if (totalSeconds == null) return "Paused";
  const seconds = Math.max(0, Math.round(totalSeconds));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  if (minutes < 60) return `${minutes}m ${remainder.toString().padStart(2, "0")}s`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${minutes % 60}m`;
}

function compactDuration(totalSeconds: number, direction: "floor" | "ceil"): string {
  const seconds = Math.max(0, totalSeconds);
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const minutes = Math.max(1, Math[direction](seconds / 60));
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return remainder ? `${hours}h ${remainder}m` : `${hours}h`;
}

export function formatDurationRange(range: [number, number]): string {
  const lower = compactDuration(range[0], "floor");
  const upper = compactDuration(range[1], "ceil");
  return lower === upper ? lower : `${lower}\u2013${upper}`;
}

export function formatGameTime(seconds: number): string {
  const day = Math.floor(seconds / 86400) + 1;
  const hour = Math.floor((seconds % 86400) / 3600);
  const minute = Math.floor((seconds % 3600) / 60);
  return `Day ${day} · ${hour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;
}
